// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum MEDIA_TYPE {
    image = 'image',
    sketch = 'sketch',
    audioNote = 'audioNote',
    link = 'link',
    embedding = 'embedding',
}
